export * from '@wix/ambassador-innovation-widget-v2-widget-settings/types';
import {
  WidgetSettings as _WidgetSettings,
  ChatHandlerMode as _ChatHandlerMode,
  ChatHandler,
} from '@wix/ambassador-innovation-widget-v2-widget-settings/types';

export type WidgetSettings = _WidgetSettings;
export type ChatHandlerMode = _ChatHandlerMode;

export const enum CurrentStatus {
  AI_ASSISTANT_ONLINE = 'AI_ASSISTANT_ONLINE',
  MANUAL_ONLINE = 'MANUAL_ONLINE',
  OFFLINE = 'OFFLINE',
}

export const getCurrentStatus = (handlers: ChatHandler[]) => {
  if (handlers?.length === 0) {
    return CurrentStatus.OFFLINE;
  } else if (handlers?.includes(ChatHandler.AI)) {
    return CurrentStatus.AI_ASSISTANT_ONLINE;
  } else if (handlers?.includes(ChatHandler.WIX_USER)) {
    return CurrentStatus.MANUAL_ONLINE;
  }
  return null;
};
